import { useContext } from "react";
import { ConfirmModalContext } from "../context/ConfirmModalContext";

export default function useConfirmModal() {
  return useContext(ConfirmModalContext);
}
